import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import ClientsContent from '../components/ClientsContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';
import withRouter from '../components/withRouter';
 
class Clients extends React.Component{
 
     constructor(props){
        super(props); 

        this.state = { 
            loading:1,
            content:"",
        }
    }

    render()
    {

        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
       
        const meta = this.props.params.id == "clients" ? metas[1] : metas[3];
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{meta.title}</title>  
                    <meta name="description" content={meta.meta_description} />
                    <meta name="keywords" content={meta.meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'clients'} />
                </Helmet>
                <PageHeader title={this.props.params.id} main_title="stakeholders"/>
                <ClientsContent content={JSON.parse(localStorage.getItem("content"))} clients={JSON.parse(localStorage.getItem("clients"))} type={this.props.params.id} />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(Clients);